import * as types from "../types";

export function getCoordinates(Lat, Long) {
  return {
    type: types.GET_COORDINATES,

    Lat,
    Long
  };
}

export function resetMap() {
  return {
    type: types.RESET_MAP
  };
}



// WEBPACK FOOTER //
// ./src/actions/GoogleMaps/googleMapsActions.js